import { applicationSettings } from '../../../settings/application';
import Bror from './bror';
import Jonaxel from './jonaxel';
import Boaxel from './boaxel';
import Aurdal from './aurdal';
import Ivar from './ivar';
import Elvarli from './elvarli';

function getRange(name) {
  switch (name) {
    case 'BROR':
      return Bror;
    case 'JONAXEL':
      return Jonaxel;
    case 'BOAXEL':
      return Boaxel;
    case 'AURDAL':
      return Aurdal;
    case 'IVAR':
      return Ivar;
    case 'ELVARLI':
      return Elvarli;
    default:
      console.error('Missing range-specific implementation ');
      return {};
  }
}

function partnerSlots(slots, otherSlots, tac) {
  return slots;
}

function causedBracketChanges(tac, item, parent) {
  return {
    add: [],
    remove: [],
  };
}

function getProppingItemsToAdapt(tac, movingItem, previous, original) {
  return [];
}

function findSuperSection(tac, member, skiplist) {
  return [];
}

function isSuperSectionHandle(item) {
  return false;
}

function getSuperSectionSpace(tac, supersection) {
  return [];
}

function getDependencyDiff(tac, options) {
  return null;
}

function getDependentItems(item, tac) {
  return [];
}

function filterSlots(slots) {
  return slots;
}

function filterVariants(tac, variants) {
  return variants;
}

function getAllowedOverlap(tac, item, relative) {
  return null;
}

function moveWithCr(item) {
  return false;
}

function isIncompleteSection(item) {
  return false;
}

function isMultiColouredSection(item, tac) {
  return false;
}

function getNeighbouringSections(section, tac, direction) {
  return [];
}

function preScreenSlots(variants, tac) {
  return variants;
}

function getCuttableMountingRailData(tac) {
  return [];
}

const api = {
  partnerSlots,
  causedBracketChanges,
  getProppingItemsToAdapt,
  findSuperSection,
  isSuperSectionHandle,
  getSuperSectionSpace,
  getDependencyDiff,
  getDependentItems,
  filterSlots,
  filterVariants,
  getAllowedOverlap,
  moveWithCr,
  isIncompleteSection,
  isMultiColouredSection,
  getNeighbouringSections,
  preScreenSlots,
  getCuttableMountingRailData,
};

const rangeApi = getRange(applicationSettings.applicationName);
Object.assign(api, rangeApi);

export const range = api;
